import { DefaultTheme } from 'styled-components';
import { layout } from './layout';

export const Theme: DefaultTheme = {
  layout,
};
